// Español (Latinoamérica). Clave = texto en inglés.
export const es: Record<string, string> = {
  "'s performance.": 'esta actuación.',
  AI: 'IA',
  'AI offline': 'IA sin conexión',
  'AI status unavailable': 'Estado de la IA no disponible',
  Active: 'Activo',
  'Add a voice track (another character or take lane)': 'Agregar una pista de voz (otro personaje o carril de tomas)',
  'Add or import some cues first': 'Primero agrega o importa algunas líneas',
  'Add player': 'Agregar jugador',
  'Adding betrayal and secret twins…': 'Agregando traiciones y gemelos secretos…',
  'All cues': 'Todas las líneas',
  Applied: 'Aplicado',
  'Apply all': 'Aplicar todo',
  'Apply suggested trim ({v} dB)': 'Aplicar el ajuste sugerido ({v} dB)',
  'Apply to': 'Aplicar a',
  Attack: 'Ataque',
  'Audible 3-2-1-BEEP': 'Cuenta regresiva audible 3-2-1-BIP',
  'Audio setup': 'Configuración de audio',
  Audition: 'Escuchar',
  Auto: 'Auto',
  'Auto-calibrate': 'Calibrar automáticamente',
  'Auto-detect': 'Detectar automáticamente',
  'Auto-detect from dialogue': 'Detectar a partir del diálogo',
  'Auto-ducking': 'Auto-ducking (bajar la música)',
  'Auto-transcribe': 'Transcribir automáticamente',
  Back: 'Atrás',
  'Back one frame (←)': 'Un cuadro atrás (←)',
  'Back to projects': 'Volver a los proyectos',
  'Bad Lip Reading': 'Lectura de labios malograda',
  'Bad lip reading, telenovela, blind dubbing and genre swap. Made for the living-room TV.':
    'Lectura de labios malograda, telenovela, doblaje a ciegas y cambio de género. Hecho para la tele de la sala.',
  'Band speed': 'Velocidad de la banda',
  'Best quality': 'Máxima calidad',
  'Blind Dubbing Challenge': 'Reto de doblaje a ciegas',
  'Both ears': 'Ambos oídos',
  'Burn subtitles into the picture': 'Grabar los subtítulos en la imagen',
  Cancel: 'Cancelar',
  Character: 'Personaje',
  'Choose a video first': 'Primero elige un video',
  'Cleaning…': 'Limpiando…',
  Clear: 'Limpiar',
  'Click "Open mic" to allow microphone access — device names appear after that.':
    'Haz clic en «Abrir micrófono» para dar permiso — después aparecen los nombres de los dispositivos.',
  'Clip cleaned (+{g} dB makeup)': 'Clip limpio (+{g} dB de ganancia)',
  'Clip gain': 'Ganancia del clip',
  Close: 'Cerrar',
  'Could not hear the clicks reliably. Turn the volume up, put the headphones next to the mic (or use speakers) and try again.':
    'No se oyeron bien los clics. Sube el volumen, acerca los audífonos al micrófono (o usa bocinas) e inténtalo de nuevo.',
  'Count-in': 'Cuenta previa',
  Create: 'Crear',
  'Create empty cue slots where someone is talking': 'Crear espacios de línea vacíos donde alguien habla',
  'Crop focus (left ↔ right)': 'Encuadre del recorte (izquierda ↔ derecha)',
  'Cue at playhead': 'Línea en el cursor',
  'Cue lane': 'Carril de líneas',
  Cues: 'Líneas',
  Delete: 'Eliminar',
  'Delete all cues?': '¿Eliminar todas las líneas?',
  'Delete selected clip / cue (Del)': 'Eliminar clip / línea seleccionada (Supr)',
  'Delete this project and its recordings?': '¿Eliminar este proyecto y sus grabaciones?',
  'Denoise this clip (server)': 'Quitar ruido de este clip (servidor)',
  'Describe what the scene is secretly about. The AI writes lines that sound like the lips are moving.':
    'Describe de qué trata en secreto la escena. La IA escribe líneas que parecen coincidir con los labios.',
  'Dialogue only': 'Solo diálogo',
  'Dialogue…': 'Diálogo…',
  Discard: 'Descartar',
  Display: 'Pantalla',
  'Do it again': 'Otra vez',
  Done: 'Listo',
  'Double-click to add': 'Doble clic para agregar',
  'Downloading model': 'Descargando modelo',
  'Drag the ruler to scrub · Shift+drag to set a punch/loop range · Ctrl+wheel to zoom':
    'Arrastra la regla para recorrer · Shift+arrastrar para marcar un rango de regrabación/bucle · Ctrl+rueda para hacer zoom',
  'Drag to draw mouth-open': 'Arrastra para marcar boca abierta',
  'Drama score': 'Puntaje de dramatismo',
  'Drama-o-meter': 'Dramatómetro',
  'Drop a video here or click to choose (.mp4 .webm .mov .mkv)': 'Suelta un video aquí o haz clic para elegir (.mp4 .webm .mov .mkv)',
  'Dub a clip, make a parody, or play a party game with friends.': 'Dobla un clip, haz una parodia o juega con tus amigos.',
  'Each line is fitted to the original syllable count and to where the lips close (M, B, P), so the dub matches the mouth.':
    'Cada línea se ajusta al número de sílabas original y a donde se cierran los labios (M, B, P), para que el doblaje coincida con la boca.',
  'Each player sees a silent segment and improvises. The next player only sees the last second of the previous performance — then continues the story!':
    'Cada jugador ve un segmento en silencio e improvisa. El siguiente solo ve el último segundo de la actuación anterior… ¡y continúa la historia!',
  Ear: 'Oído',
  'Echo cancellation (for speakers; slightly degrades the voice)': 'Cancelación de eco (para bocinas; degrada un poco la voz)',
  'Effect amount': 'Intensidad del efecto',
  Encoding: 'Codificando',
  'Every line becomes an over-the-top soap-opera declaration.': 'Cada línea se vuelve una declaración exagerada de telenovela.',
  'Everyday dialogue becomes a soap-opera meltdown. Deliver it with maximum emotion.':
    'Un diálogo cotidiano se vuelve un drama de telenovela. Interprétalo con la máxima emoción.',
  'Everyone shares one mic. Use the arrow keys / Enter or a clicker — it works from the sofa.':
    'Todos comparten un micrófono. Usa las flechas / Enter o un control remoto — funciona desde el sillón.',
  Export: 'Exportar',
  'Export the video': 'Exportar el video',
  'Extra instructions, e.g. "Translate into English matching the original 7 syllables, with M/B/P where the character closes their lips" or "keep it formal"':
    'Instrucciones extra, p. ej. «Traduce al inglés respetando las 7 sílabas originales, con M/B/P donde el personaje cierra los labios» o «mantén un tono formal»',
  'Fast export: the original video stream is copied untouched, only the new audio is added — near instant.':
    'Exportación rápida: el video original se copia sin tocarlo y solo se agrega el audio nuevo — casi instantáneo.',
  'Finding where people talk…': 'Buscando dónde habla la gente…',
  Finish: 'Terminar',
  'Fit to window': 'Ajustar a la ventana',
  Format: 'Formato',
  'Forward one frame (→)': 'Un cuadro adelante (→)',
  From: 'De',
  'From playhead': 'Desde el cursor',
  'Full mix': 'Mezcla completa',
  'Full render: video is re-encoded (slower).': 'Render completo: el video se recodifica (más lento).',
  GO: '¡YA!',
  Games: 'Juegos',
  Generate: 'Generar',
  'Genre Swapper': 'Cambio de género',
  'Genre: 80s action movie': 'Género: película de acción de los 80',
  'Genre: Bad corporate speak': 'Género: jerga corporativa insoportable',
  'Genre: Noir detective': 'Género: detective noir',
  'Genre: Pirate': 'Género: pirata',
  'Get dialogue text': 'Obtener el texto del diálogo',
  'Ghost audio guide': 'Guía de audio fantasma',
  'Give each line MAXIMUM emotion — gasp, sob, whisper, scream!': '¡Dale a cada línea la MÁXIMA emoción — jadea, solloza, susurra, grita!',
  'Give every player a silly voice effect': 'Dar a cada jugador un efecto de voz chistoso',
  'Go to cue': 'Ir a la línea',
  Headphones: 'Audífonos',
  'Headphones only. The guide is never part of the export. With separated stems the music bed plays normally and the dialogue is the ghost.':
    'Solo con audífonos. La guía nunca forma parte de la exportación. Con las pistas separadas, la música suena normal y el diálogo es el fantasma.',
  'Headphones: no bleed into the mic, so you can hear the original or the ghost guide while recording.':
    'Audífonos: no se filtra sonido al micrófono, así que puedes oír el original o la guía fantasma mientras grabas.',
  'Hear myself (headphones only!)': 'Escucharme (¡solo con audífonos!)',
  'Hello {name}': 'Hola {name}',
  "I'm ready": 'Estoy listo',
  'If the TV adds lag (HDMI/Bluetooth), nudge the picture delay until lips match the sound.':
    'Si la tele añade retraso (HDMI/Bluetooth), ajusta el retraso de imagen hasta que los labios coincidan con el sonido.',
  'Import .srt / .vtt': 'Importar .srt / .vtt',
  'Import subtitles': 'Importar subtítulos',
  'Input 1 / Left': 'Entrada 1 / Izquierda',
  'Input 2 / Right': 'Entrada 2 / Derecha',
  'Input device': 'Dispositivo de entrada',
  'Input trim': 'Ganancia de entrada',
  'Interface channel': 'Canal de la interfaz',
  'Keep the original music + sound effects in the reveal (if separable)':
    'Conservar la música y los efectos originales en la revelación (si se pueden separar)',
  Language: 'Idioma',
  'Latency compensation': 'Compensación de latencia',
  'Left ear only': 'Solo oído izquierdo',
  Level: 'Nivel',
  Line: 'Línea',
  'Lip flaps': 'Movimiento de labios',
  'Lip-flap markers': 'Marcadores de labios',
  'Listening to the clip…': 'Escuchando el clip…',
  'Loading audio…': 'Cargando audio…',
  'Loading…': 'Cargando…',
  Loop: 'Bucle',
  'Loop playback of the selected range (L)': 'Reproducir en bucle el rango seleccionado (L)',
  'Loop takes (cue/range)': 'Tomas en bucle (línea/rango)',
  'Loop the selected cue or the dragged range (L)': 'Bucle de la línea seleccionada o del rango marcado (L)',
  'Loop-record this cue until you nail it': 'Grabar esta línea en bucle hasta que te salga',
  'Lower the background when I speak': 'Bajar el fondo cuando yo hable',
  "Manual: hold the M key while the character's mouth is open (while playing). Or drag in the Lip flaps lane. Pink bars show when to speak; red line = now.":
    'Manual: mantén la tecla M mientras la boca del personaje esté abierta (durante la reproducción), o arrastra en el carril de labios. Las barras rosas indican cuándo hablar; la línea roja = ahora.',
  'Match the original sounds (runs speech recognition first — better lip fit)':
    'Imitar los sonidos originales (primero reconoce el habla — encaja mejor con los labios)',
  'Measured round-trip latency: {ms} ms (applied).': 'Latencia de ida y vuelta medida: {ms} ms (aplicada).',
  'Mic check': 'Prueba de micrófono',
  'Mic fix: rumble filter + gentle leveling (great for budget mics)':
    'Arreglo de micrófono: filtro de retumbos + nivelación suave (ideal para micrófonos económicos)',
  'Mic open': 'Micrófono abierto',
  'Micro-nudge': 'Micro-ajuste',
  Microphone: 'Micrófono',
  'Microphone / audio interface': 'Micrófono / interfaz de audio',
  'Microphone error: {m}': 'Error de micrófono: {m}',
  Mix: 'Mezcla',
  'Mix both': 'Mezclar ambos',
  'Mixed video + separate WAV stems: music/SFX, voice dry, voice wet. Plus .srt and .json.':
    'Video mezclado + pistas WAV separadas: música/efectos, voz limpia, voz con efectos. Más .srt y .json.',
  Mode: 'Modo',
  Model: 'Modelo',
  "Mono audio can't be separated this way. Use the volume and ducking controls instead.":
    'El audio mono no se puede separar así. Usa mejor el volumen y el ducking.',
  'More games': 'Más juegos',
  'Music + SFX only': 'Solo música + efectos',
  'Music + SFX only (actors silenced)': 'Solo música + efectos (actores en silencio)',
  Mute: 'Silenciar',
  'Mute original': 'Silenciar original',
  'Mute original audio while recording': 'Silenciar el audio original mientras grabo',
  'Muxing video…': 'Uniendo el video…',
  Name: 'Nombre',
  'New line': 'Línea nueva',
  'New project': 'Proyecto nuevo',
  'New round': 'Nueva ronda',
  'No API key: translation is unavailable, party tasks use the offline fun-generator.':
    'Sin clave de API: la traducción no está disponible; los juegos usan el generador divertido sin conexión.',
  'No cues yet. Import subtitles, auto-transcribe, or double-click the cue lane in the timeline.':
    'Aún no hay líneas. Importa subtítulos, transcribe automáticamente o haz doble clic en el carril de líneas de la línea de tiempo.',
  'No projects yet — create one and drop in a video clip.': 'Todavía no hay proyectos — crea uno y suelta un clip de video.',
  'No speech detected': 'No se detectó habla',
  'No speech found in this clip. Try Bad Lip Reading, which does not need dialogue.':
    'No se encontró habla en este clip. Prueba la Lectura de labios malograda, que no necesita diálogo.',
  'No speech found to derive mouth movements from': 'No hay habla de la cual derivar los movimientos de boca',
  'No speech found.': 'No se encontró habla.',
  'No takes yet. Press ⏺ to record.': 'Aún no hay tomas. Presiona ⏺ para grabar.',
  'Noir, pirates, corporate jargon or an 80s action hero take over the dialogue.':
    'Noir, piratas, jerga corporativa o un héroe de acción de los 80 se apoderan del diálogo.',
  'Normalize loudness (−16 LUFS)': 'Normalizar el volumen (−16 LUFS)',
  'Nothing recorded — try again.': 'No se grabó nada — inténtalo de nuevo.',
  'Now speak normally for 3 seconds (e.g. "testing one two three")…': 'Ahora habla normal durante 3 segundos (p. ej. «probando uno dos tres»)…',
  'Nudge shifts this whole track earlier (−) or later (+) after recording — fix small sync errors by ear.':
    'El micro-ajuste adelanta (−) o atrasa (+) toda esta pista después de grabar — corrige pequeños desfases de oído.',
  'On speakers the mic hears the video sound. The original audio is muted while recording (you will still see the cues and picture). Use headphones for ghost-guide and music beds.':
    'Con bocinas el micrófono oye el sonido del video. El audio original se silencia al grabar (seguirás viendo las líneas y la imagen). Usa audífonos para la guía fantasma y la música de fondo.',
  'Open mic': 'Abrir micrófono',
  'Open your microphone first (Voice tab)': 'Primero abre tu micrófono (pestaña Voz)',
  'OpenRouter usage (hard-capped locally)': 'Uso de OpenRouter (con tope local)',
  'Original audio': 'Audio original',
  'Original volume': 'Volumen del original',
  Output: 'Salida',
  'Output device (headphones / TV)': 'Dispositivo de salida (audífonos / TV)',
  'Output switched': 'Salida cambiada',
  'Parody & Party': 'Parodia y Fiesta',
  Party: 'Fiesta',
  'Pass the mic to': 'Pásale el micrófono a',
  'Pass the mic: each player dubs a silent segment seeing only the last second of the previous player.':
    'Pásense el micrófono: cada jugador dobla un segmento en silencio viendo solo el último segundo del jugador anterior.',
  'Pick a game': 'Elige un juego',
  'Pick a genre — the AI keeps the timing but changes the voice.': 'Elige un género — la IA conserva los tiempos pero cambia la voz.',
  'Picture delay': 'Retraso de imagen',
  Play: 'Reproducir',
  'Play / pause (Space)': 'Reproducir / pausa (Espacio)',
  'Play the chaotic reveal!': '¡Reproducir la caótica revelación!',
  'Play the original dialogue in my headphones': 'Reproducir el diálogo original en mis audífonos',
  'Play this cue': 'Reproducir esta línea',
  'Play with our voices': 'Reproducir con nuestras voces',
  Player: 'Jugador',
  Players: 'Jugadores',
  'Playing test clicks… keep the room quiet. The mic must be able to hear the speakers/headphones.':
    'Reproduciendo clics de prueba… mantén silencio. El micrófono debe poder oír las bocinas/audífonos.',
  Preparing: 'Preparando',
  'Preparing proxy video, audio and thumbnails…': 'Preparando video proxy, audio y miniaturas…',
  Pro: 'Pro',
  'Pro Dub Studio': 'Estudio de doblaje Pro',
  'Project name': 'Nombre del proyecto',
  'Punch range': 'Rango de regrabación',
  'Quick share': 'Compartir rápido',
  REC: 'REC',
  'Re-separate': 'Separar de nuevo',
  'Read the lines as they light up — the sillier the better!': 'Lee las líneas conforme se iluminan — ¡entre más ridículo, mejor!',
  'Reading the lips…': 'Leyendo los labios…',
  'Record (R)': 'Grabar (R)',
  'Record this cue (punch)': 'Grabar esta línea (regrabación)',
  'Recorded clips are placed earlier by this amount so your voice lines up with what you saw and heard. USB interfaces ≈ 15–40 ms, Bluetooth headphones 150–300 ms.':
    'Los clips grabados se colocan antes por esta cantidad para que tu voz coincida con lo que viste y oíste. Interfaces USB ≈ 15–40 ms, audífonos Bluetooth 150–300 ms.',
  'Recording setup': 'Configuración de grabación',
  Redo: 'Rehacer',
  Reduction: 'Reducción',
  Release: 'Relajación',
  'Remove from list': 'Quitar de la lista',
  'Remove this track and its clips?': '¿Quitar esta pista y sus clips?',
  'Remove track': 'Quitar pista',
  Rename: 'Renombrar',
  Rendering: 'Renderizando',
  'Replace existing cues with empty speech slots?': '¿Reemplazar las líneas existentes por espacios de habla vacíos?',
  'Replace existing cues?': '¿Reemplazar las líneas existentes?',
  'Replace the {n} existing cues with the {m} imported ones? (Cancel = append)':
    '¿Reemplazar las {n} líneas existentes por las {m} importadas? (Cancelar = agregar al final)',
  Replay: 'Repetir',
  'Replay it': 'Verlo de nuevo',
  'Rewrite the scene!': '¡Reescribe la escena!',
  'Rewriting the scene…': 'Reescribiendo la escena…',
  'Right ear only': 'Solo oído derecho',
  'Round trip': 'Ida y vuelta',
  'Saving project and uploading takes…': 'Guardando el proyecto y subiendo las tomas…',
  Segment: 'Segmento',
  Segments: 'Segmentos',
  'Select a cue first (click it in the Cues tab or the cue lane)': 'Primero selecciona una línea (haz clic en la pestaña Líneas o en el carril de líneas)',
  'Select a cue or Shift+drag a range first': 'Primero selecciona una línea o Shift+arrastra un rango',
  'Select a cue or Shift+drag a range to loop-record': 'Selecciona una línea o Shift+arrastra un rango para grabar en bucle',
  'Selected cue': 'Línea seleccionada',
  'Selected cue only': 'Solo la línea seleccionada',
  'Separate dialogue / music': 'Separar diálogo / música',
  Separating: 'Separando',
  'Separating dialogue from music + sound effects': 'Separando el diálogo de la música y los efectos',
  'Separating… (a few seconds per minute of video)': 'Separando… (unos segundos por minuto de video)',
  'Setting up the game…': 'Preparando el juego…',
  'Shift+drag on the timeline to choose the range to re-record': 'Shift+arrastra en la línea de tiempo para elegir el rango a regrabar',
  'Show karaoke subtitles on the video': 'Mostrar subtítulos tipo karaoke sobre el video',
  'Silencing the original actors…': 'Silenciando a los actores originales…',
  'Small H.264/AAC (or WebM) for Discord, WhatsApp, chat.': 'H.264/AAC pequeño (o WebM) para Discord, WhatsApp y chats.',
  Solo: 'Solo',
  'Solo original': 'Solo el original',
  'Speech recognition runs on this computer': 'El reconocimiento de voz corre en esta computadora',
  'Speech slots': 'Espacios de habla',
  Split: 'Cortar',
  'Split the selected clip at the playhead (S)': 'Cortar el clip seleccionado en el cursor (S)',
  'Splits the clip audio into Original Dialogue and Background (music + sound effects) so you can silence the actors but keep the score, gunshots and ambience.':
    'Separa el audio del clip en Diálogo original y Fondo (música + efectos) para que puedas silenciar a los actores y conservar la música, los disparos y el ambiente.',
  'Start performance': 'Comenzar la actuación',
  'Start the challenge!': '¡Comienza el reto!',
  'Starting speech recognition…': 'Iniciando el reconocimiento de voz…',
  'Stay in character!': '¡No salgas del personaje!',
  'Stay quiet for 2 seconds…': 'Quédate en silencio 2 segundos…',
  'Stems ready': 'Pistas listas',
  'Stems ready: dialogue muted, music + SFX kept': 'Pistas listas: diálogo silenciado, música y efectos conservados',
  Stop: 'Detener',
  'Studio archive': 'Archivo de estudio',
  'Summoning melodrama…': 'Invocando el melodrama…',
  'TV / speakers': 'TV / bocinas',
  'TV mode (big UI, fullscreen)': 'Modo TV (interfaz grande, pantalla completa)',
  'TV speakers: original sound is muted while you perform': 'Bocinas de la TV: el sonido original se silencia mientras actúas',
  Take: 'Toma',
  'Take:': 'Toma:',
  Takes: 'Tomas',
  'Takes on': 'Tomas en',
  'Target size': 'Tamaño objetivo',
  Task: 'Tarea',
  'Telenovela Overdrive': 'Telenovela al máximo',
  'Telenovela overdrive': 'Telenovela al máximo',
  'The AI invents absurd lines that fit the mouths. You read them karaoke-style.':
    'La IA inventa líneas absurdas que encajan con las bocas. Tú las lees estilo karaoke.',
  'The AI is rewriting every line…': 'La IA está reescribiendo cada línea…',
  'The AI is writing absurd lines…': 'La IA está escribiendo líneas absurdas…',
  'The chaotic reveal': 'La caótica revelación',
  'The dialogue will be transcribed automatically (or import subtitles).': 'El diálogo se transcribirá automáticamente (o importa subtítulos).',
  'The green line on the original-audio lane shows the ducking envelope.': 'La línea verde sobre el carril del audio original muestra la curva del ducking.',
  'The picture is silent — make up the dialogue!': 'La imagen está en silencio — ¡inventa el diálogo!',
  'The reveal': 'La revelación',
  'Thinking…': 'Pensando…',
  'This clip already has a script / recordings:': 'Este clip ya tiene guion / grabaciones:',
  'This clip is mono — voice and music cannot be separated by phase. Use ducking instead.':
    'Este clip es mono — la voz y la música no se pueden separar por fase. Usa mejor el ducking.',
  Timeline: 'Línea de tiempo',
  'Timeline, rhythm band, lip-sync markers, ghost guide and translation. For practicing real dubbing.':
    'Línea de tiempo, banda rítmica, marcadores de labios, guía fantasma y traducción. Para practicar doblaje de verdad.',
  To: 'A',
  'Track volume': 'Volumen de la pista',
  'Transcribing…': 'Transcribiendo…',
  'Translate (syllable-matched)': 'Traducir (ajustado a sílabas)',
  'Translation & localization assistant': 'Asistente de traducción y localización',
  'Trim set to {v} dB': 'Ganancia ajustada a {v} dB',
  'Undo (Ctrl/⌘+Z)': 'Deshacer (Ctrl/⌘+Z)',
  'Uploading…': 'Subiendo…',
  Use: 'Usar',
  'Use this line': 'Usar esta línea',
  'Vertical 9:16 (Reels / TikTok / Shorts)': 'Vertical 9:16 (Reels / TikTok / Shorts)',
  Video: 'Video',
  Voice: 'Voz',
  'Voice effect': 'Efecto de voz',
  'Voice track': 'Pista de voz',
  Volume: 'Volumen',
  'Watermark text (optional)': 'Texto de marca de agua (opcional)',
  'What are they REALLY talking about?': '¿De qué están hablando REALMENTE?',
  'What to record': 'Qué grabar',
  'Which part of the original to play': 'Qué parte del original reproducir',
  'Write the script!': '¡Escribe el guion!',
  'You get the very first segment — start the story!': 'Te toca el primer segmento — ¡empieza la historia!',
  'You will first see the last second of': 'Primero verás el último segundo de',
  'Your projects': 'Tus proyectos',
  'Zoom in (+)': 'Acercar (+)',
  'Zoom out (-)': 'Alejar (-)',
  about: 'aprox.',
  calls: 'llamadas',
  'centre-channel extraction — good for dialogue panned to the middle, imperfect on busy mixes':
    'extracción del canal central — buena si el diálogo está al centro, imperfecta en mezclas cargadas',
  'click “Use” to put a take on the timeline (it replaces what is there). Nothing is ever deleted from disk.':
    'haz clic en «Usar» para poner una toma en la línea de tiempo (reemplaza lo que haya). Nunca se borra nada del disco.',
  cues: 'líneas',
  dialogue: 'diálogo',
  'from the 5.1 centre channel — clean': 'del canal central 5.1 — limpio',
  'local cap': 'tope local',
  'mic closed': 'micrófono cerrado',
  'mic not open': 'micrófono sin abrir',
  'mic on': 'micrófono activo',
  'mic ready': 'micrófono listo',
  'mono input': 'entrada mono',
  'music+sfx': 'música+efectos',
  'noise floor': 'ruido de fondo',
  off: 'apagado',
  'offline generator': 'generador sin conexión',
  peak: 'pico',
  're-encoded': 'recodificado',
  'save failed': 'error al guardar',
  saved: 'guardado',
  'saved in': 'guardado en',
  'saving…': 'guardando…',
  segments: 'segmentos',
  'server?': '¿servidor?',
  speech: 'voz',
  spent: 'gastado',
  'stream copy': 'copia directa',
  'syllables · syllables per second (above ~7/s is hard to say)': 'sílabas · sílabas por segundo (arriba de ~7/s es difícil de decir)',
  takes: 'tomas',
  'tip: separate dialogue first for a cleaner result': 'consejo: separa primero el diálogo para un resultado más limpio',
  '{n} cues from speech recognition.': '{n} líneas del reconocimiento de voz.',
  '{n} cues imported': '{n} líneas importadas',
  '{n} dialogue lines found.': 'Se encontraron {n} líneas de diálogo.',
  '{n} empty cue slots created — fill them in or use the AI tab': 'Se crearon {n} espacios vacíos — llénalos o usa la pestaña IA',
  '{n} mouth-open markers': '{n} marcadores de boca abierta',
  '{n} take(s) recorded on “{track}”': '{n} toma(s) grabada(s) en «{track}»',
  // dynamic labels
  Clean: 'Limpia',
  'Walkie-Talkie': 'Walkie-Talkie',
  Monster: 'Monstruo',
  Helium: 'Helio',
  Ghost: 'Fantasma',
  'Tiny multilingual (≈40 MB, fastest)': 'Mínimo multilingüe (≈40 MB, el más rápido)',
  'Base multilingual (≈80 MB, better)': 'Base multilingüe (≈80 MB, mejor)',
  'Small multilingual (≈250 MB, best, slow on CPU)': 'Pequeño multilingüe (≈250 MB, el mejor, lento en CPU)',
  'Your mic level and noise floor look good.': 'El nivel y el ruido de fondo de tu micrófono se ven bien.',
  'Nothing came through. Check the mic/interface is plugged in, the right input is selected, and the gain knob on the interface is up.':
    'No llegó nada. Revisa que el micrófono/interfaz esté conectado, que esté elegida la entrada correcta y que la perilla de ganancia de la interfaz esté arriba.',
  'Too loud — it is clipping. Turn the gain knob on the interface down (or the trim slider here) and stay ~15 cm from the mic.':
    'Demasiado fuerte — está saturando. Baja la perilla de ganancia de la interfaz (o el control de ganancia de aquí) y mantente a ~15 cm del micrófono.',
  'Very quiet. Raise the interface gain knob first (best), then the trim slider here.':
    'Muy bajo. Sube primero la perilla de ganancia de la interfaz (lo mejor) y luego el control de ganancia de aquí.',
  'A bit quiet. Raise the gain a little; use the suggested trim below.': 'Un poco bajo. Sube un poco la ganancia; usa el ajuste sugerido de abajo.',
  'Background noise is high. Move closer to the mic, turn off fans, and enable "Clean up" on the track.':
    'Hay mucho ruido de fondo. Acércate al micrófono, apaga ventiladores y activa «Limpiar» en la pista.',
  'Voice is not much louder than the noise. Get closer to the mic or add trim.':
    'La voz no es mucho más fuerte que el ruido. Acércate al micrófono o sube la ganancia.',
  'Only built-in or virtual inputs are visible. If you expected a USB audio interface, check that its cable carries data (not charge-only), try another port, then press Rescan.':
    'Solo se ven entradas integradas o virtuales. Si esperabas una interfaz de audio USB, revisa que su cable transmita datos (no solo carga), prueba otro puerto y presiona Reescanear.',
  'Rescan devices': 'Reescanear dispositivos',
  Mark: 'Marca',
  'No mark': 'No hay marca',
  'set one with ⌘/Ctrl+number': 'crea una con ⌘/Ctrl+número',
  'Marks: ⌘/Ctrl+number sets, ⌥/Option+number jumps (Shift+number also sets)': 'Marcas: ⌘/Ctrl+número crea, ⌥/Option+número salta (Shift+número también crea)',
  '⌘/Ctrl+1…9 set a mark · ⌥/Option+1…9 jump': '⌘/Ctrl+1…9 crea una marca · ⌥/Option+1…9 salta',
  'Jump to mark {n} (⌥{n}) — right-click to delete': 'Saltar a la marca {n} (⌥{n}) — clic derecho para borrar',
  'Keyboard shortcuts': 'Atajos de teclado',
  'Keyboard shortcuts (?)': 'Atajos de teclado (?)',
  'Play / pause': 'Reproducir / pausa',
  'Record / stop (uses the “What to record” mode)': 'Grabar / detener (usa el modo «Qué grabar»)',
  'Stop everything': 'Detener todo',
  'Step one frame (Shift: one second)': 'Avanzar un cuadro (Shift: un segundo)',
  'Go to start / end': 'Ir al inicio / al final',
  'Set mark (Shift + 1…9 also works if the browser keeps ⌘+number)': 'Crear marca (Shift + 1…9 también sirve si el navegador se queda con ⌘+número)',
  'Jump to mark — keeps playing / recording / paused as it was': 'Saltar a la marca — sigue reproduciendo / grabando / en pausa como estaba',
  'Set range in / out at the playhead': 'Marcar inicio / fin del rango en el cursor',
  'Loop the selected cue or range': 'Bucle de la línea o rango seleccionado',
  'Split the clip at the playhead': 'Cortar el clip en el cursor',
  'Delete selected clip or cue': 'Eliminar el clip o la línea seleccionada',
  'Mark mouth-open while playing': 'Marcar boca abierta durante la reproducción',
  'Undo / redo': 'Deshacer / rehacer',
  'Zoom the timeline': 'Zoom de la línea de tiempo',
  'TV mode': 'Modo TV',
  'This help': 'Esta ayuda',
  'both inputs carry signal': 'ambas entradas tienen señal',
  'using Input 1 / Left (the other input is silent)': 'usando la Entrada 1 / Izquierda (la otra está en silencio)',
  'using Input 2 / Right (the other input is silent)': 'usando la Entrada 2 / Derecha (la otra está en silencio)',
  'Projects and recordings are stored on this computer.': 'Los proyectos y las grabaciones se guardan en esta computadora.',
  'No projects. Choose New project, then pick a video file.': 'No hay proyectos. Elige Proyecto nuevo y selecciona un archivo de video.',
  Length: 'Duración',
  Modified: 'Modificado',
  'No takes yet. Press R to record.': 'Aún no hay tomas. Presiona R para grabar.',
  'New lines written to fit the mouths on screen. You read them as they appear.':
    'Líneas nuevas escritas para encajar con las bocas en pantalla. Tú las lees conforme aparecen.',
  Telenovela: 'Telenovela',
  'The scene’s dialogue rewritten as melodrama. You perform it.': 'El diálogo de la escena reescrito como melodrama. Tú lo interpretas.',
  'Blind Dubbing': 'Doblaje a ciegas',
  'Each player dubs a silent segment, seeing only the last second of the previous player.':
    'Cada jugador dobla un segmento en silencio, viendo solo el último segundo del jugador anterior.',
  'Genre Swap': 'Cambio de género',
  'The dialogue rewritten as noir, pirate, corporate or 80s action.': 'El diálogo reescrito como noir, piratas, jerga corporativa o acción de los 80.',
  'One microphone, passed around. Up/Down and Enter to choose, F for TV mode.':
    'Un micrófono que se pasa de mano en mano. Arriba/Abajo y Enter para elegir, F para el modo TV.',
  'This clip already has a script or recordings.': 'Este clip ya tiene guion o grabaciones.',
  'Analyzing the clip…': 'Analizando el clip…',
  'Writing lines…': 'Escribiendo líneas…',
  'Read each line as it highlights.': 'Lee cada línea conforme se resalta.',
  'Write script': 'Escribir guion',
  'Describe what the scene is really about. Lines are written to match the syllables of each mouth movement.':
    'Describe de qué trata realmente la escena. Las líneas se escriben para coincidir con las sílabas de cada movimiento de boca.',
  'What are they really talking about?': '¿De qué están hablando realmente?',
  'Match the original sounds (runs speech recognition first; fits the lips better)':
    'Imitar los sonidos originales (primero reconoce el habla; encaja mejor con los labios)',
  'Rewriting dialogue…': 'Reescribiendo el diálogo…',
  'Deliver each line with exaggerated emotion.': 'Interpreta cada línea con emoción exagerada.',
  'Stay in character.': 'No salgas del personaje.',
  'Rewrite dialogue': 'Reescribir el diálogo',
  'Every line is rewritten as soap-opera melodrama.': 'Cada línea se reescribe como melodrama de telenovela.',
  'Pick a genre. Timing is kept; the wording changes.': 'Elige un género. Los tiempos se conservan; cambian las palabras.',
  'Waiting for the first line': 'Esperando la primera línea',
  Start: 'Comenzar',
  Intensity: 'Intensidad',
  'Play with recordings': 'Reproducir con las grabaciones',
  Pause: 'Pausa',
  Result: 'Resultado',
  'Record again': 'Grabar otra vez',
  Ready: 'Listo',
  'You get the first segment. Start the story.': 'Te toca el primer segmento. Empieza la historia.',
  'Play result': 'Reproducir el resultado',
  Undo: 'Deshacer',
  'Go to start (Home)': 'Ir al inicio (Inicio)',
  'Separating…': 'Separando…',
  'This clip is mono, so phase separation cannot split it. Use “Best quality (neural)”.':
    'Este clip es mono, así que la separación por fase no puede dividirlo. Usa «Máxima calidad (neuronal)».',
  'This clip is mono. Install the neural separator (pnpm setup:separation) or use ducking.':
    'Este clip es mono. Instala el separador neuronal (pnpm setup:separation) o usa el ducking.',
  'Not installed. Run: pnpm setup:separation': 'No está instalado. Ejecuta: pnpm setup:separation',
  'Best quality (neural)': 'Máxima calidad (neuronal)',
  'neural separation (Demucs)': 'separación neuronal (Demucs)',
  'This clip is mono, so phase separation cannot split it. Use “Best quality (neural)”: it takes about as long as the clip.':
    'Este clip es mono, así que la separación por fase no puede dividirlo. Usa «Máxima calidad (neuronal)»: tarda aproximadamente lo que dura el clip.',
  'This clip is mono. Install the neural separator (pnpm setup:separation) or use the volume and ducking controls.':
    'Este clip es mono. Instala el separador neuronal (pnpm setup:separation) o usa el volumen y el ducking.',
  'Splits the clip audio into Original Dialogue and Background (music + sound effects) so you can silence the actors but keep the score, gunshots and ambience. “Best quality (neural)” also works on mono clips, takes about as long as the clip, and runs on this computer.':
    'Separa el audio del clip en Diálogo original y Fondo (música + efectos) para que puedas silenciar a los actores y conservar la música, los disparos y el ambiente. «Máxima calidad (neuronal)» también funciona con clips mono, tarda aproximadamente lo que dura el clip y se ejecuta en esta computadora.',
  'Starting…': 'Iniciando…',
  'Analysing voices': 'Analizando voces',
  '{n} voices found': 'Se encontraron {n} voces',
  'Identify again': 'Identificar de nuevo',
  'Identify voices': 'Identificar voces',
  'Character name': 'Nombre del personaje',
  'Silence this character in the original audio, so you can dub it': 'Silenciar a este personaje en el audio original, para que puedas doblarlo',
  Off: 'Apagado',
  On: 'Activo',
  'Hear only this character': 'Oír solo a este personaje',
  'Listen to this character': 'Escuchar a este personaje',
  'Selected passage': 'Pasaje seleccionado',
  'Number of voices': 'Número de voces',
  'Voices (who is speaking)': 'Voces (quién habla)',
  'Separate the dialogue first: voices are identified on the clean dialogue track.':
    'Primero separa el diálogo: las voces se identifican sobre la pista de diálogo limpia.',
  'Turn a character Off to hear the clip without that voice, then record your own over it. Click a coloured block in the Voices lane to check or correct who is speaking.':
    'Apaga a un personaje para oír el clip sin esa voz y grabar la tuya encima. Haz clic en un bloque de color del carril de Voces para revisar o corregir quién habla.',
  'Finds each distinct voice in the clip so you can silence one character at a time. Runs on this computer.':
    'Encuentra cada voz distinta del clip para que puedas silenciar un personaje a la vez. Se ejecuta en esta computadora.',
  Voices: 'Voces',
  voice: 'voz',
  voices: 'voces',
  Podcast: 'Podcast',
  'Record audio and video with your camera and microphone, then trim, add chapters, clean up the voice and export.':
    'Graba audio y video con tu cámara y micrófono; luego recorta, agrega capítulos, limpia la voz y exporta.',
  'Optional: drop an existing recording here, or leave empty and record in the next step':
    'Opcional: suelta aquí una grabación existente, o déjalo vacío y graba en el siguiente paso',
  'Choose your camera and microphone, check the level, then record.': 'Elige tu cámara y micrófono, revisa el nivel y graba.',
  'Audio only: no camera will be recorded.': 'Solo audio: no se grabará la cámara.',
  'Camera unavailable: {m}. You can still record audio only.': 'Cámara no disponible: {m}. Aún puedes grabar solo audio.',
  Camera: 'Cámara',
  clipping: 'saturando',
  Chapter: 'Capítulo',
  'Add chapter': 'Agregar capítulo',
  'Saving failed: {m}': 'Error al guardar: {m}',
  'Recording. Each second is saved to disk as it is captured.': 'Grabando. Cada segundo se guarda en el disco conforme se captura.',
  'Paused.': 'En pausa.',
  Resume: 'Reanudar',
  Record: 'Grabar',
  'Finishing the recording…': 'Terminando la grabación…',
  'Record audio and video straight from your camera and microphone. Chapters you add while recording are saved with the episode.':
    'Graba audio y video directo de tu cámara y micrófono. Los capítulos que agregues mientras grabas se guardan con el episodio.',
  Sources: 'Fuentes',
  'Record video': 'Grabar video',
  Press: 'Presiona',
  Trim: 'Recorte',
  'Start here (I)': 'Inicio aquí (I)',
  'End here (O)': 'Fin aquí (O)',
  Chapters: 'Capítulos',
  'No chapters. Add one at the playhead with M. Podcast apps show them as a table of contents.':
    'Sin capítulos. Agrega uno en el cursor con M. Las apps de podcast los muestran como índice.',
  'Add chapter at playhead (M)': 'Agregar capítulo en el cursor (M)',
  Transcript: 'Transcripción',
  Transcribe: 'Transcribir',
  'Voice clean-up': 'Limpieza de voz',
  'Remove low rumble (desk thumps, hum)': 'Quitar retumbos graves (golpes de escritorio, zumbido)',
  'Reduce background noise': 'Reducir el ruido de fondo',
  'Even out volume (gentle compression)': 'Igualar el volumen (compresión suave)',
  'Normalize loudness to −16 LUFS (podcast standard)': 'Normalizar el volumen a −16 LUFS (estándar de podcast)',
  'Whole recording': 'Toda la grabación',
  'New recording': 'Grabación nueva',
  'Click the waveform to move; drag the amber handles to trim.': 'Haz clic en la onda para moverte; arrastra las asas ámbar para recortar.',
  'Your recording is already saved automatically. Choose a format and press Export to get a file, or download the untouched original.':
    'Tu grabación ya se guardó automáticamente. Elige un formato y presiona Exportar para obtener un archivo, o descarga el original sin modificar.',
  'Download original': 'Descargar el original',
  bad: 'mal',
  'Two people arguing about lost cheese': 'Dos personas discutiendo por un queso perdido',
  'two people arguing about lost cheese': 'dos personas discutiendo por un queso perdido',
  'a cooking show where everything catches fire': 'un programa de cocina donde todo se incendia',
  'a dramatic breakup over a WiFi password': 'una ruptura dramática por la contraseña del WiFi',
  'two spies who forgot the secret code': 'dos espías que olvidaron la clave secreta',
  'a nature documentary about a very lazy cat': 'un documental de naturaleza sobre un gato muy flojo',
  'Noir Detective': 'Detective noir',
  'Pirate Swashbuckler': 'Pirata aventurero',
  'Bad Corporate Speak': 'Jerga corporativa insoportable',
  '80s Action Movie': 'Película de acción de los 80',
  'Gritty inner monologue, 1940s slang, rain on the window.': 'Monólogo interior crudo, jerga de los años 40, lluvia en la ventana.',
  'Nautical insults, treasure and the odd sea shanty.': 'Insultos marinos, tesoros y alguna canción de marineros.',
  'Synergistic alignment and quarterly targets.': 'Alineación sinérgica y metas trimestrales.',
  'Every line ends with an explosion-ready one-liner.': 'Cada línea termina con una frase lista para una explosión.',
  'Noise floor': 'Ruido de fondo',
  'Open the project': 'Abrir el proyecto',
  'Language of the interface': 'Idioma de la interfaz',
  // context menus
  Open: 'Abrir',
  'Delete project': 'Eliminar proyecto',
  'Loop this range': 'Repetir este rango',
  'Re-record this range (punch in)': 'Regrabar este rango (pinchazo)',
  'Clear range': 'Quitar el rango',
  'Edit text': 'Editar el texto',
  'Delete cue': 'Eliminar línea',
  'Jump to mark {n}': 'Ir a la marca {n}',
  'Delete mark {n}': 'Eliminar la marca {n}',
  'Play from here': 'Reproducir desde aquí',
  'Set mark {n} here': 'Poner la marca {n} aquí',
  'All nine marks are set': 'Las nueve marcas están en uso',
  'Listen to this passage': 'Escuchar este fragmento',
  'Turn {name} back on': 'Volver a activar a {name}',
  'Silence {name} (to dub it)': 'Silenciar a {name} (para doblarlo)',
  'This passage is {name}': 'Este fragmento es de {name}',
  'Add a cue here': 'Agregar una línea aquí',
  'Delete this mouth-open marker': 'Eliminar este marcador de boca abierta',
  'Add a mouth-open marker here': 'Agregar un marcador de boca abierta aquí',
  'Play from the start of this clip': 'Reproducir desde el inicio de este clip',
  'Split at the playhead': 'Cortar en el cursor',
  'Reset clip gain': 'Restablecer la ganancia del clip',
  'Delete clip': 'Eliminar clip',
  'Record on “{track}” from here': 'Grabar en «{track}» desde aquí',
  'Move mark {n} to the playhead': 'Mover la marca {n} al cursor',
  'Record on this track': 'Grabar en esta pista',
  Unmute: 'Activar sonido',
  Unsolo: 'Quitar solo',
  'Use this take': 'Usar esta toma',
  'Use only the part inside the range': 'Usar solo la parte dentro del rango',
  'Show or hide subtitles on the video': 'Mostrar u ocultar los subtítulos en el video',
  'Hear everyone': 'Escuchar a todos',
  'Hear only {name}': 'Escuchar solo a {name}',
  'Go to chapter': 'Ir al capítulo',
  'Move chapter to the playhead': 'Mover el capítulo al cursor',
  'Delete chapter': 'Eliminar capítulo',
  // workflow tabs, devices, prepare, marks
  Script: 'Guion',
  Marks: 'Marcas',
  Devices: 'Dispositivos',
  'Set up mic': 'Configurar micrófono',
  'Microphone, headphones, camera and latency': 'Micrófono, auriculares, cámara y latencia',
  'Pick your microphone, check that the meter moves when you speak, and say whether you wear headphones.':
    'Elige tu micrófono, revisa que el medidor se mueva cuando hablas y di si usas auriculares.',
  'Show camera': 'Mostrar cámara',
  'Used by podcast recordings. Dubbing does not need a camera.': 'Lo usan las grabaciones de podcast. El doblaje no necesita cámara.',
  Listening: 'Escucha',
  'Test sound': 'Probar sonido',
  'Plays two short beeps': 'Reproduce dos pitidos cortos',
  'Are you wearing headphones?': '¿Usas auriculares?',
  'No microphone open yet.': 'Todavía no hay un micrófono abierto.',
  'Choose and open your microphone first': 'Primero elige y abre tu micrófono',
  'Separate dialogue from music': 'Separar diálogo de la música',
  Subtitles: 'Subtítulos',
  Speakers: 'Hablantes',
  'Keeps the score and effects when you silence a voice.': 'Conserva la música y los efectos cuando silencias una voz.',
  'Speech recognition on this computer; the lines become cues.': 'Reconocimiento de voz en esta computadora; las frases se vuelven líneas.',
  'Finds each voice and gives it its own lane; cues get the character name.':
    'Encuentra cada voz y le da su propio carril; las líneas reciben el nombre del personaje.',
  'Prepare this clip': 'Preparar este clip',
  'Prepare all': 'Preparar todo',
  Run: 'Ejecutar',
  'Language of the dialogue': 'Idioma del diálogo',
  'Mono clip: using the neural separator (about as long as the clip)…': 'Clip mono: usando el separador neuronal (tarda más o menos lo que dura el clip)…',
  'Mono clip and no neural separator installed (pnpm setup:separation).': 'Clip mono y sin separador neuronal instalado (pnpm setup:separation).',
  '{n} cues': '{n} líneas',
  'Needs the dialogue separated first.': 'Primero hay que separar el diálogo.',
  'Prepare automatically: separate dialogue, subtitles and speakers': 'Preparar automáticamente: separar diálogo, subtítulos y hablantes',
  'Add mark at the playhead': 'Agregar marca en el cursor',
  'Name (optional)': 'Nombre (opcional)',
  '⌘/Ctrl+1…9 set a mark · ⌥/Option+1…9 jump · [ and ] go to the previous / next mark. Jumping while recording keeps recording.':
    '⌘/Ctrl+1…9 crea una marca · ⌥/Option+1…9 salta · [ y ] van a la marca anterior / siguiente. Saltar mientras grabas sigue grabando.',
  'No marks yet. Press ⌘/Ctrl+1 at a spot you want to come back to.': 'Aún no hay marcas. Presiona ⌘/Ctrl+1 en un punto al que quieras volver.',
  'Previous / next mark': 'Marca anterior / siguiente',
  // splitting
  'Split passage here': 'Cortar el fragmento aquí',
  'Split cue here': 'Cortar la línea aquí',
  'Split clip here': 'Cortar el clip aquí',
  'Nothing to split at the playhead': 'No hay nada que cortar en el cursor',
  'Split the selected passage, cue or clip at the playhead': 'Cortar en el cursor el fragmento, la línea o el clip seleccionado',
  'Split the selected passage, cue or clip at the playhead (S)': 'Cortar en el cursor el fragmento, la línea o el clip seleccionado (S)',
  // saving and the File menu
  'Could not save. Your changes are still here; try again.': 'No se pudo guardar. Tus cambios siguen aquí; inténtalo de nuevo.',
  'Saving…': 'Guardando…',
  'Unsaved changes': 'Cambios sin guardar',
  'Save failed': 'Error al guardar',
  'Saved {time}': 'Guardado {time}',
  Saved: 'Guardado',
  'New project…': 'Proyecto nuevo…',
  'Open…': 'Abrir…',
  'Export…': 'Exportar…',
  'Close project': 'Cerrar proyecto',
  File: 'Archivo',
  Save: 'Guardar',
  // clip library
  'New dubbing project from this clip': 'Nuevo proyecto de doblaje con este clip',
  'New party project from this clip': 'Nuevo proyecto de fiesta con este clip',
  'New podcast project from this clip': 'Nuevo proyecto de podcast con este clip',
  Dub: 'Doblaje',
  Library: 'Biblioteca',
  'Clips and projects are stored on this computer.': 'Los clips y proyectos se guardan en esta computadora.',
  'Party: pick a clip': 'Fiesta: elige un clip',
  'Add clip': 'Agregar clip',
  'Clip library': 'Biblioteca de clips',
  'Prepare a clip once (dialogue, subtitles, characters), then start as many dubbing, party or podcast projects from it as you like.':
    'Prepara un clip una vez (diálogo, subtítulos, personajes) y crea con él todos los proyectos de doblaje, fiesta o podcast que quieras.',
  Projects: 'Proyectos',
  'No clips yet. Add a funny video or a movie scene, prepare it once, and play it as often as you like.':
    'Aún no hay clips. Agrega un video gracioso o una escena de película, prepáralo una vez y úsalo cuantas veces quieras.',
  Clip: 'Clip',
  Lines: 'Líneas',
  'Start a project': 'Crear un proyecto',
  'Not prepared yet: open it and press Prepare all': 'Sin preparar: ábrelo y presiona Preparar todo',
  'Importing…': 'Importando…',
  'New {mode} project from this clip': 'Nuevo proyecto de {mode} con este clip',
  'Delete this clip? Projects made from it keep working.': '¿Eliminar este clip? Los proyectos creados con él siguen funcionando.',
  from: 'de',
  'a deleted clip': 'un clip eliminado',
  'Add a clip to the library': 'Agregar un clip a la biblioteca',
  'A clip is prepared once (dialogue, subtitles, characters). Recordings happen in projects you start from it.':
    'Un clip se prepara una vez (diálogo, subtítulos, personajes). Las grabaciones se hacen en los proyectos que crees con él.',
  'A library clip: prepare dialogue, subtitles and characters here; record in projects started from it.':
    'Un clip de la biblioteca: prepara aquí el diálogo, los subtítulos y los personajes; graba en los proyectos que crees con él.',
  'Library clip': 'Clip de biblioteca',
  'Clips are not recorded on. Start a project from this clip to record.': 'En los clips no se graba. Crea un proyecto con este clip para grabar.',
  // party: pick a clip, play a character
  'Next player': 'Siguiente jugador',
  'Play a character': 'Interpreta a un personaje',
  'Pick who you play: their voice goes silent and their lines light up while the rest of the scene plays.':
    'Elige a quién interpretas: su voz se silencia y sus líneas se iluminan mientras el resto de la escena sigue.',
  'Your lines light up; everyone else in the scene plays as usual. Headphones keep the scene out of your microphone.':
    'Tus líneas se iluminan; el resto de la escena suena normal. Con auriculares la escena no entra a tu micrófono.',
  'Pick at least one character': 'Elige al menos un personaje',
  'Pick who you play. Their voice goes silent and their lines light up.': 'Elige a quién interpretas. Su voz se silencia y sus líneas se iluminan.',
  'Your name (optional)': 'Tu nombre (opcional)',
  'Who is playing?': '¿Quién juega?',
  'Which character(s) do you play?': '¿Qué personaje(s) interpretas?',
  'This clip has no characters yet. Prepare it in the library first (Voices → Prepare all).':
    'Este clip aún no tiene personajes. Prepáralo primero en la biblioteca (Voces → Preparar todo).',
  'The dialogue of this clip is not separated, so the original voices cannot be silenced.':
    'El diálogo de este clip no está separado, así que las voces originales no se pueden silenciar.',
  'no characters yet': 'aún sin personajes',
  'Pick a clip': 'Elige un clip',
  'Choose a scene, then the character you will play. Up/Down and Enter work from the sofa.':
    'Elige una escena y luego el personaje que vas a interpretar. Arriba/Abajo y Enter funcionan desde el sillón.',
  'The clip library is empty. Add clips from the library first.': 'La biblioteca de clips está vacía. Agrega clips desde la biblioteca primero.',
  Clips: 'Clips',
  // party room (TV + phones) and background audio
  'Party room (phones)': 'Sala de fiesta (celulares)',
  'Party on one device': 'Fiesta en un solo dispositivo',
  'Background audio': 'Audio de fondo',
  'Played on the waiting phones during a party round, so nobody hears the lines before the show.':
    'Suena en los celulares que esperan durante una ronda, para que nadie oiga las frases antes del estreno.',
  'Loading the library…': 'Cargando la biblioteca…',
  'The clip library is empty. Add a video to the library and prepare it (subtitles and voices) first.':
    'La biblioteca de clips está vacía. Agrega un video a la biblioteca y prepáralo primero (subtítulos y voces).',
  '{n} characters': '{n} personajes',
  'Not prepared: no characters yet': 'Sin preparar: todavía no tiene personajes',
  'Remove {name} from the room': 'Sacar a {name} de la sala',
  Join: 'Unirse',
  'QR code to join': 'Código QR para unirse',
  'Scan with your phone, or open': 'Escanéalo con el celular, o abre',
  'Room code': 'Código de sala',
  players: 'jugadores',
  'We will speak': 'Hablaremos en',
  'The lines are written in it, and the phones hear what each player said in it.':
    'Las frases se escriben en este idioma, y los teléfonos entienden lo que dijo cada jugador en él.',
  'The phones hear what each player said in it, whatever the language of the scene.':
    'Los teléfonos entienden lo que dijo cada jugador en este idioma, sea cual sea el idioma de la escena.',
  'Remove {name}? Their {n} passages are removed from the timeline and the original dialogue goes silent in those places.':
    '¿Quitar a {name}? Sus {n} fragmentos se quitan de la línea de tiempo y el diálogo original queda en silencio en esos lugares.',
  'Remove {name}? They have no passages in the timeline.': '¿Quitar a {name}? No tiene fragmentos en la línea de tiempo.',
  '{name} removed. Undo brings them back.': 'Se quitó a {name}. Deshacer lo trae de vuelta.',
  'Remove {name}…': 'Quitar a {name}…',
  'Remove this character': 'Quitar este personaje',
  'everyone plays': 'juegan todos',
  'People per round': 'Personas por ronda',
  Everyone: 'Todos',
  'How {name} ended': 'Cómo terminó {name}',
  'Listen…': 'Escucha…',
  'Their words are still being transcribed. Listen to how it ended.': 'Todavía se están transcribiendo sus palabras. Escucha cómo terminó.',
  'Pick up from there. Next you see your silent stretch of the scene.': 'Sigue desde ahí. Ahora verás tu parte de la escena, sin sonido.',
  'Hear it again': 'Escuchar otra vez',
  'Playing…': 'Reproduciendo…',
  'pick up from where they ended.': 'sigue desde donde terminó.',
  'Players ({n})': 'Jugadores ({n})',
  Disconnected: 'Desconectado',
  'Nobody yet': 'Nadie todavía',
  'The first visit on each phone shows a security warning (this computer’s own certificate): choose to continue.':
    'La primera vez, cada celular muestra un aviso de seguridad (es el certificado propio de esta computadora): elige continuar.',
  'Test with phones on this computer': 'Probar con celulares en esta computadora',
  Recording: 'Grabando',
  'Listening back': 'Escuchando la toma',
  Sending: 'Enviando',
  'Getting ready': 'Preparándose',
  'Could not open a party room: {error}': 'No se pudo abrir la sala: {error}',
  'Try again': 'Reintentar',
  'Opening the room…': 'Abriendo la sala…',
  'Round {n}': 'Ronda {n}',
  '{n} lines': '{n} frases',
  Cast: 'Reparto',
  '{n} people': '{n} personas',
  'Time per line': 'Tiempo por frase',
  '{n} s': '{n} s',
  Order: 'Orden',
  'Scene order': 'Orden de la escena',
  Shuffled: 'Al azar',
  'Scene length': 'Duración de la escena',
  'Whole clip': 'Clip entero',
  'Suggest funny lines (AI)': 'Sugerir frases graciosas (IA)',
  'Change clip': 'Cambiar clip',
  'Cast the round': 'Repartir papeles',
  'Waiting for players': 'Esperando jugadores',
  'The cast': 'El reparto',
  as: 'como',
  'Everyone else: headphones on when someone records. Cast: look at your phone.':
    'Los demás: audífonos puestos cuando alguien grabe. El reparto: miren su celular.',
  'Line {n} of {total}': 'Frase {n} de {total}',
  'Headphones on, everyone else.': 'Los demás, audífonos puestos.',
  '+15 s': '+15 s',
  'Skip this line': 'Saltar esta frase',
  'Finish now': 'Terminar ya',
  'Putting it together…': 'Montándolo todo…',
  'Reconnecting…': 'Reconectando…',
  '{n} of {total} lines dubbed': '{n} de {total} frases dobladas',
  'Play it': 'Reproducir',
  'Next round': 'Siguiente ronda',
  'Open in the studio': 'Abrir en el estudio',
  'Adding {name}…': 'Agregando {name}…',
  'Could not add {name}: {error}': 'No se pudo agregar {name}: {error}',
  Listen: 'Escuchar',
  Remove: 'Quitar',
  'Add background audio': 'Agregar audio de fondo',
  'No background audio yet. Add music or noise (any audio or video file): waiting phones play it in headphones while someone records.':
    'Todavía no hay audio de fondo. Agrega música o ruido (cualquier archivo de audio o video): los celulares que esperan lo ponen en los audífonos mientras alguien graba.',
  'Tap to play the background music': 'Toca para poner la música de fondo',
  'No background music in the library: cover your ears.': 'No hay música de fondo en la biblioteca: tápate los oídos.',
  'Doblaje party': 'Fiesta de doblaje',
  'Test phones': 'Celulares de prueba',
  Room: 'Sala',
  Phones: 'Celulares',
  'Phone {n}': 'Celular {n}',
  'Join the party': 'Únete a la fiesta',
  'Grab your headphones. You will record your lines on this phone.': 'Ten a mano tus audífonos. Vas a grabar tus frases en este celular.',
  'Your name': 'Tu nombre',
  'Nothing was recorded. Check the microphone and try again.': 'No se grabó nada. Revisa el micrófono y vuelve a intentarlo.',
  Idea: 'Idea',
  'Say the line, change it, or say anything you like.': 'Di la frase, cámbiala o di lo que quieras.',
  'Watch the scene': 'Ver la escena',
  Send: 'Enviar',
  'Sending…': 'Enviando…',
  'Allow the microphone to record your lines. ({error})': 'Permite el micrófono para grabar tus frases. ({error})',
  'Joining room {code}…': 'Entrando en la sala {code}…',
  'Room {code}': 'Sala {code}',
  'You are in': 'Ya estás dentro',
  'Waiting for the TV to start the round. Have your headphones at hand.': 'Esperando a que la tele empiece la ronda. Ten los audífonos a mano.',
  'You play': 'Eres',
  'Put your headphones on. When it is your turn this phone shows your line, you record it, and send it.':
    'Ponte los audífonos. Cuando te toque, este celular te muestra tu frase: la grabas y la envías.',
  'Headphones on, I am ready': 'Audífonos puestos, estoy listo',
  'Ready. Watch the TV.': 'Listo. Mira la tele.',
  'Not this round': 'Esta ronda no te toca',
  'Watch the TV. When someone records, put your headphones on: this phone plays music so you do not hear them.':
    'Mira la tele. Cuando alguien grabe, ponte los audífonos: este celular pone música para que no lo oigas.',
  'Your turn': 'Te toca',
  'The scene could not load.': 'No se pudo cargar la escena.',
  'Loading your scene…': 'Cargando tu escena…',
  'Recording now': 'Grabando ahora',
  'Headphones on. No peeking, no listening.': 'Audífonos puestos. Ni mirar ni escuchar.',
  'Look at the TV.': 'Mira la tele.',
  'Look at the TV': 'Mira la tele',
  'Headphones off. Here comes the dub.': 'Fuera audífonos. Llega el doblaje.',
  'Leave room': 'Salir de la sala',
  End: 'Fin',
  'Watermark position': 'Posición de la marca de agua',
  // party room game modes
  'Writing the script…': 'Escribiendo el guion…',
  'Dub the scene': 'Doblar la escena',
  'Everyone says the real lines in their own voice (the AI can suggest funnier ones).':
    'Cada uno dice las frases reales con su voz (la IA puede sugerir otras más graciosas).',
  'New lines written to fit the mouths on screen, about whatever you choose.':
    'Frases nuevas escritas para encajar con las bocas en pantalla, sobre lo que elijas.',
  'The scene’s dialogue rewritten as melodrama.': 'El diálogo de la escena reescrito como melodrama.',
  'No script: each player improvises a silent stretch, hearing only how the last one ended.':
    'Sin guion: cada jugador improvisa un tramo sin sonido y solo oye cómo terminó el anterior.',
  Game: 'Juego',
  Genre: 'Género',
  Turns: 'Turnos',
  'Make up what they say. The scene is silent: it is all yours.': 'Inventa lo que dicen. La escena está en silencio: es toda tuya.',
  'You start the story.': 'Tú empiezas la historia.',
  'You are in this round': 'Juegas esta ronda',
  'No script: you improvise {n} silent stretches of the scene. Nobody hears anything until the show.':
    'Sin guion: improvisas {n} tramos de la escena sin sonido. Nadie oye nada hasta el estreno.',
  // party room as a show
  'Play at a party': 'Jugar en una fiesta',
  'Party room': 'Sala de fiesta',
  'Prepare a clip once (dialogue, subtitles, characters), then play it at a party or start dubbing and podcast projects from it.':
    'Prepara un clip una vez (diálogo, subtítulos, personajes) y luego juégalo en una fiesta o empieza proyectos de doblaje y podcast con él.',
  'Open a party room with this clip': 'Abrir una sala de fiesta con este clip',
  'Prepare the clip first: it needs characters': 'Prepara el clip primero: necesita personajes',
  'Party games are played with a prepared library clip: add the video as a clip, prepare it, then choose Play at a party.':
    'Los juegos de fiesta se juegan con un clip preparado de la biblioteca: agrega el video como clip, prepáralo y elige Jugar en una fiesta.',
  'Party round': 'Ronda de fiesta',
  '{n} takes': '{n} tomas',
  'Nobody recorded in this round.': 'Nadie grabó en esta ronda.',
  '{n} takes in total': '{n} tomas en total',
  Watch: 'Ver',
  'Play another round': 'Jugar otra ronda',
  'Could not open a party room': 'No se pudo abrir la sala de fiesta',
  'Cutting the scene down to what you dubbed, then every take goes on its own track over it.':
    'Recortando la escena a lo que doblaron; luego cada toma va a su propia pista encima.',
  Scene: 'Escena',
  Setup: 'Preparación',
  'Join on your phone': 'Únete con tu celular',
  'Getting the round ready': 'Preparando la ronda',
  'Scene: {from} to {to}': 'Escena: de {from} a {to}',
  'Cast: {n} players': 'Reparto: {n} jugadores',
  'Writing {n} lines for {game}…': 'Escribiendo {n} frases para {game}…',
  'The AI writes the lines when it is available; otherwise they are made on this computer. It takes a few seconds.':
    'La IA escribe las frases cuando está disponible; si no, se hacen en esta computadora. Tarda unos segundos.',
  'Look at your phone: it shows your part. Everyone else, headphones on when someone records.':
    'Mira tu celular: muestra tu papel. Los demás, audífonos puestos cuando alguien grabe.',
  '{n} turns': '{n} turnos',
  'Watch again': 'Ver otra vez',
  'Another round': 'Otra ronda',
  'Change the game': 'Cambiar el juego',
  'Change the scene': 'Cambiar la escena',
  'Scene: {name}': 'Escena: {name}',
  'Choose the game': 'Elige el juego',
  'How it plays': 'Cómo se juega',
  'Next: invite players': 'Siguiente: invitar jugadores',
  'Everyone joins on their phone': 'Cada uno se une con su celular',
  'Connect your phone to this Wi-Fi.': 'Conecta tu celular a esta red Wi-Fi.',
  'Scan the code with the camera, or open {url} and type the room code.': 'Escanea el código con la cámara, o abre {url} y escribe el código de sala.',
  'If the phone warns about the connection, choose to continue: it is this computer’s own certificate.':
    'Si el celular avisa sobre la conexión, elige continuar: es el certificado propio de esta computadora.',
  'Keep your headphones at hand. Nobody hears anyone’s lines until the show.': 'Ten los audífonos a mano. Nadie oye las frases de nadie hasta el estreno.',
  Rules: 'Reglas',
  '{n} s per line': '{n} s por frase',
  'Start the round': 'Empezar la ronda',
  'Pick a scene': 'Elige una escena',
  'Choose a clip from the library. Players can join while you set up.': 'Elige un clip de la biblioteca. Los jugadores pueden unirse mientras preparas.',
  'Next: choose the game': 'Siguiente: elegir el juego',
  'is improvising': 'está improvisando',
  'seconds left': 'segundos',
  'Lines of the round': 'Frases de la ronda',
  'Everyone else: headphones on.': 'Los demás: audífonos puestos.',
  'Everyone says the real lines in their own voice.': 'Cada uno dice las frases reales con su voz.',
  'Each player gets a character of the scene.': 'A cada jugador le toca un personaje de la escena.',
  'Your phone shows your line, with an idea for a funnier one if you want it.': 'Tu celular muestra tu frase, con una idea más graciosa si la quieres.',
  'The TV plays the scene with everyone’s voices.': 'La tele pone la escena con las voces de todos.',
  'You choose what the scene is really about.': 'Tú eliges de qué trata la escena en realidad.',
  'Your phone shows the new line that fits the mouth movements.': 'Tu celular muestra la frase nueva que encaja con las bocas.',
  'The TV plays the scene with the new lines as subtitles.': 'La tele pone la escena con las frases nuevas como subtítulos.',
  'Every line is rewritten as a soap opera.': 'Cada frase se reescribe como telenovela.',
  'Your phone shows your melodramatic line. Overact.': 'Tu celular muestra tu frase melodramática. Exagera.',
  'The TV plays the drama.': 'La tele pone el drama.',
  'You pick a genre.': 'Tú eliges un género.',
  'Your phone shows your line in that genre.': 'Tu celular muestra tu frase en ese género.',
  'The TV plays the scene in its new genre.': 'La tele pone la escena en su nuevo género.',
  'The scene is cut into silent stretches, one per turn.': 'La escena se corta en tramos sin sonido, uno por turno.',
  'Your phone plays the last second of the previous player, then you improvise.': 'Tu celular pone el último segundo del jugador anterior y luego improvisas.',
  'The TV plays the whole story nobody has heard.': 'La tele pone la historia completa que nadie ha oído.',
  'Your colour on the TV.': 'Tu color en la tele.',
  'Look at the TV: the host is choosing the scene and the game. Keep your headphones at hand.':
    'Mira la tele: el anfitrión está eligiendo la escena y el juego. Ten los audífonos a mano.',
  'Who has written': 'Quién ya escribió',
  'Nobody is free to write this one: the AI will.': 'Nadie puede escribir esta: la escribe la IA.',
  Votes: 'Votos',
  '{n} ideas. Everyone who wrote is voting on their phone.': '{n} ideas. Quienes escribieron están votando en su celular.',
  'Chosen.': 'Elegida.',
  'The AI is writing it…': 'La IA la está escribiendo…',
  'Cutting the scenes together with title cards, then every take goes on its own track over them.':
    'Uniendo las escenas con tarjetas de título; después cada toma va en su propia pista encima.',
  'What is this movie about?': '¿De qué trata esta película?',
  'Watch the clip. Everyone pitches it on their phone, then votes.': 'Mira el clip. Todos lo proponen en su celular y luego votan.',
  'The clip, without sound': 'El clip, sin sonido',
  'The pitch': 'La propuesta',
  '{n} scenes': '{n} escenas',
  '{n} of {total} scenes recorded': '{n} de {total} escenas grabadas',
  'The title cards and the AI’s ideas are written in it, and the phones hear what each player said in it.':
    'Las tarjetas de título y las ideas de la IA se escriben en ese idioma, y la tele escucha lo que dijo cada jugador en él.',
  '{n} s per scene': '{n} s por escena',
  'Time per scene': 'Tiempo por escena',
  'Scene {n} of {total}': 'Escena {n} de {total}',
  'The last scene is in': 'La última escena ya está',
  'Waiting for the title': 'Esperando el título',
  'Waiting for its direction': 'Esperando su dirección',
  'The title': 'El título',
  'Direction for scene {n}': 'Dirección de la escena {n}',
  '{name} has written a review.': '{name} ya escribió su reseña.',
  '{name} is writing a review.': '{name} está escribiendo su reseña.',
  'This summer': 'Este verano',
  'Coming soon': 'Próximamente',
  'Trailer Director': 'Director de tráiler',
  'The room pitches a movie about the clip, directs every scene, and the result is its trailer.':
    'La sala propone una película sobre el clip, dirige cada escena y el resultado es su tráiler.',
  'Everyone pitches what the clip is about, and votes for the best pitch.': 'Todos proponen de qué trata el clip y votan la mejor propuesta.',
  'You perform scenes with no script, told what happens by the others, while they direct the next one and a critic writes a quote.':
    'Actúas escenas sin guion, con lo que pasa dicho por los demás, mientras ellos dirigen la siguiente y un crítico escribe una cita.',
  'The TV plays the trailer: title cards, critics and the title the room chose.':
    'La tele pone el tráiler: tarjetas de título, críticos y el título que eligió la sala.',
  'Direction from the room': 'Dirección de la sala',
  'The scene is silent. Say what you like: the room’s idea is only a hint.':
    'La escena no tiene sonido. Di lo que quieras: la idea de la sala es solo una pista.',
  'You are in this trailer': 'Estás en este tráiler',
  'You perform {n} scenes with no script: the room tells you what happens in each. While the others record, you pitch, direct, vote and write reviews.':
    'Actúas {n} escenas sin guion: la sala te dice qué pasa en cada una. Mientras los demás graban, propones, diriges, votas y escribes reseñas.',
  'One moment': 'Un momento',
  'The room is still deciding. Look at the TV.': 'La sala aún está decidiendo. Mira la tele.',
  'The scene, without sound': 'La escena, sin sonido',
  '{name} is recording. Headphones on.': '{name} está grabando. Audífonos puestos.',
  Sent: 'Enviado',
  'Send the change': 'Enviar el cambio',
  'The movie: {pitch}': 'La película: {pitch}',
  'Sent. Waiting for the others.': 'Enviado. Esperando a los demás.',
  'Which pitch is best?': '¿Cuál es la mejor propuesta?',
  'Which direction is best?': '¿Cuál es la mejor dirección?',
  'Which title is best?': '¿Cuál es el mejor título?',
  Vote: 'Votar',
  'Tap one. It cannot be yours.': 'Toca una. No puede ser la tuya.',
  'Voted. Waiting for the others.': 'Votaste. Esperando a los demás.',
  'The movie': 'La película',
  'Watch the clip and pitch it in one line. Everyone’s ideas go to a vote.': 'Mira el clip y propón de qué trata en una frase. Las ideas de todos se votan.',
  'A bank heist, but with hamsters': 'Un asalto a un banco, pero con hámsters',
  'Direct the next scene': 'Dirige la siguiente escena',
  'What happens here?': '¿Qué pasa aquí?',
  'The scene before was about: {before}': 'La escena anterior trataba de: {before}',
  'The player who records it will read your idea.': 'Quien la grabe leerá tu idea.',
  'They open the vault and find cheese': 'Abren la bóveda y encuentran queso',
  'The last scene is being recorded': 'Se está grabando la última escena',
  'Title the movie': 'Ponle título a la película',
  'Cheddar Hard': 'Duro de queso',
  'You are the critic': 'Eres el crítico',
  'What will the papers say?': '¿Qué dirán los periódicos?',
  'You have not seen it. Write a quote for the trailer.': 'No la has visto. Escribe una cita para el tráiler.',
  'A triumph of the human spirit': 'Un triunfo del espíritu humano',
  Scenes: 'Escenas',
  'Which description is best?': '¿Cuál es la mejor descripción?',
  'Create a character': 'Crea un personaje',
  'Who is {name}?': '¿Quién es {name}?',
  'Describe their voice and personality in a few words. Someone else may end up playing them, and nobody sees this until the cast is revealed.':
    'Describe su voz y su personalidad en pocas palabras. Otra persona puede acabar interpretándolo, y nadie ve esto hasta que se revele el reparto.',
  'Gruff, slow talker, suspicious of cheese': 'Gruñón, habla despacio, desconfía del queso',
  '{name} speaks in it: {card}': '{name} habla en ella: {card}',
  'no description yet': 'aún sin descripción',
  'Create the characters': 'Crea los personajes',
  'Each player describes one character on their phone: how they sound and what they are like. Nobody knows who will play them.':
    'Cada jugador describe un personaje en su celular: cómo suena y cómo es. Nadie sabe quién lo interpretará.',
  Written: 'Escrito',
  'Writing…': 'Escribiendo…',
  'Describe the characters first': 'Describir los personajes primero',
  'Each player writes a character’s voice and personality before the cast is revealed, and the card follows the character.':
    'Cada jugador escribe la voz y la personalidad de un personaje antes de revelar el reparto, y la ficha sigue al personaje.',
  or: 'o',
  'Create a room': 'Crear una sala',
  'You will host it from this phone and play too. Share the link with your friends.':
    'Serás el anfitrión desde este celular y también jugarás. Comparte el enlace con tus amigos.',
  'The room': 'La sala',
  '{name} is recording': '{name} está grabando',
  Progress: 'Progreso',
  'Starting in {n}': 'Empieza en {n}',
  'Here it is': 'Aquí está',
  'The result': 'El resultado',
  'Tap to watch together': 'Toca para verlo juntos',
  Download: 'Descargar',
  'This room’s files are deleted when everyone has left. Download the result to keep it.':
    'Los archivos de esta sala se borran cuando todos se van. Descarga el resultado para conservarlo.',
  'You are the host': 'Eres el anfitrión',
  'Link copied': 'Enlace copiado',
  'Invite friends': 'Invitar amigos',
  'Join my party: {url}': 'Únete a mi fiesta: {url}',
  'Loading the clips…': 'Cargando los clips…',
  'This server has no clips ready yet.': 'Este servidor aún no tiene clips listos.',
  'Pick a scene first': 'Elige una escena primero',
  'Writing the lines…': 'Escribiendo las frases…',
  'Change the game or the scene': 'Cambiar el juego o la escena',
  'Choose the scene and the game, then invite your friends.': 'Elige la escena y el juego, y luego invita a tus amigos.',
  'The host is choosing the scene and the game. Keep your headphones at hand.': 'El anfitrión está eligiendo la escena y el juego. Ten los audífonos a mano.',
  'The show': 'La función',
  'Headphones off. Here comes the dub. If there is a TV, look at it.': 'Sin audífonos. Aquí viene el doblaje. Si hay una tele, mírala.',
  'Preparing the result…': 'Preparando el resultado…',
  'Could not prepare the result: {error}': 'No se pudo preparar el resultado: {error}',
  'Sign in to create a room': 'Inicia sesión para crear una sala',
  'Signed in as {name}.': 'Sesión iniciada como {name}.',
  'Sign out': 'Cerrar sesión',
  'Open my library': 'Abrir mi biblioteca',
};
